import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"
// import FileDownload from 'js-file-download';

const obj = {
    uploadBoletas: async (params) => {
        console.log("uploadBoletas", params);
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + "massiveboletauploader",
            params,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
  downloadZip: async ({ folios}) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(
            apiurl + "zipboletasmasivas",
            { folios},   
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                
            }
        );
    }
};

export default obj;